import React from 'react';
import { Layout, Row, Col, Typography, Grid } from 'antd';
import logoImage from '../../assets/3.png';
import versionData from '../../version.json';

const { Footer: AntFooter } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

const Footer = () => {
  const screens = useBreakpoint();

  return (
    <AntFooter
      style={{
        backgroundColor: '#000000',
        width:'100%',
        height: 'auto',
        padding: screens.lg ? '10px 24px' : '12px 16px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Row
        style={{
          width: '100%',
          height: '100%',
          alignItems: 'center',
        }}
        gutter={screens.lg ? [16, 0] : [0, 8]}
      >
        <Col xs={24} lg={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={logoImage}
            alt="Logo"
            style={{
              maxHeight: screens.lg ? '40px' : '30px',
              maxWidth: '100%',
              objectFit: 'contain',
            }}
          />
        </Col>
        <Col xs={24} lg={18} style={{ display: 'flex', alignItems: 'center', justifyContent: screens.lg ? 'flex-end' : 'center', textAlign: screens.lg ? 'right' : 'center' }}>
          <Text
            style={{
              color: 'rgba(255,255,255,0.8)',
              fontSize: screens.lg ? '12px' : '10px',
              lineHeight: '1.4',
            }}
          >
            © Copyright 2026 Adandyou Business Integration, Ltd. All Rights Reserved. | Supported by adandyou.mx | v{versionData.version}
          </Text>
        </Col>
      </Row>
    </AntFooter>
  );
};

export default Footer;
